import { useNavigate } from 'react-router-dom'

import { Box, Flex, Grid, FloraTag, FloraTypography } from '@grupoboticario/flora-react'

import { useUserContext } from '@/context/user'
import { Acceleration } from '@/icons/Acceleration'
import { Participants } from '@/icons/Participants'
import { Actions } from '@/utils/dictionaries/actionsDictionary/actions'

import * as H from './home.styles'

interface ShortcutItem {
  title: string
  icon: React.ReactNode
  href: string
  action: string
  isNew: boolean
  description: string
}

const shortcutItems: ShortcutItem[] = [
  {
    title: 'Participantes',
    icon: <Participants />,
    href: '/members',
    action: Actions.LIST_USERS,
    isNew: false,
    description:
      'Gestão de participantes do clube através das funções de consulta, edição de cadastro e extrato de pontos'
  },
  {
    title: 'Acelerador de pontos',
    icon: <Acceleration />,
    href: '/acceleration',
    action: Actions.LIST_ACCELERATIONS,
    isNew: false,
    description: 'Criação, consulta de listas de campanhas de aceleração de pontos'
  }
]

const HomePage = () => {
  const navigate = useNavigate()
  const { hasPermission } = useUserContext()

  return (
    <Grid css={H.gridCss} gap="$6" templateColumns="repeat(auto-fill, minmax(304px, 1fr))">
      {shortcutItems.map((item, index) => (
        <Flex
          css={H.getCardFlexCss(hasPermission(item.action))}
          direction="column"
          gap="$2"
          key={index}
          onClick={() => {
            navigate(item.href)
          }}
        >
          {item.isNew && (
            <FloraTag css={H.newTagCss} assortedStyle={9} styleSemantic="assorted" type="readOnly" size="medium">
              Novidade
            </FloraTag>
          )}
          <Box css={H.getIconBoxCss(hasPermission(item.action))}>{item.icon}</Box>
          <Box>
            <FloraTypography css={H.getCardTextCss()} fontSize="bodyLargeStandard">
              {item.title}
            </FloraTypography>
          </Box>
          <Box>
            <FloraTypography css={H.getCardTextCss()} fontSize="exceptionsAuxiliar">
              {item.description}
            </FloraTypography>
          </Box>
        </Flex>
      ))}
    </Grid>
  )
}

export { HomePage }
